import { SPACING_24, SpacingVertical, Wizard } from 'mailup-web-components'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { changeWizardStepCallback } from '../recoil/callbacks/callbacks'
import {
  pageState,
  wizardEnableStep1State,
  wizardEnableStep2State,
  wizardEnableStep3State,
  wizardEnableStep4State,
  wizardEnableStep5State
} from '../recoil/state/page'
import TaskStep1 from './Step1/TaskStep1'
import TaskStep2 from './Step2/TaskStep2'
import TaskStep3 from './Step3/TaskStep3'
import TaskStep4 from './Step4/TaskStep4'
import TaskStep5 from './Step5/TaskStep5'

const WizardContainer = () => {
  const intl = useIntl()
  const { wizardStep } = useRecoilValue(pageState)
  const enableStep1 = useRecoilValue(wizardEnableStep1State)

  const enableStep2 = useRecoilValue(wizardEnableStep2State)
  const enableStep3 = useRecoilValue(wizardEnableStep3State)
  const enableStep4 = useRecoilValue(wizardEnableStep4State)
  const enableStep5 = useRecoilValue(wizardEnableStep5State)

  const changeWizardStep = useRecoilCallback(changeWizardStepCallback, [])

  const options = [
    {
      label: intl.formatMessage({ id: 'Load.Task.Step1InfoGeneral' }),
      value: 1,
      enabled: enableStep1
    },
    {
      label: intl.formatMessage({ id: 'Load.Task.Step2Action' }),
      value: 2,
      enabled: enableStep2
    },
    {
      label: intl.formatMessage({ id: 'Load.Task.Step3Condictions' }),
      value: 3,
      enabled: enableStep3
    },
    {
      label: intl.formatMessage({ id: 'Load.Task.Step4ActFreq' }),
      value: 4,
      enabled: enableStep4
    },
    {
      label: intl.formatMessage({ id: 'Load.Task.Step5Recap' }),
      value: 5,
      enabled: enableStep5
    }
  ]

  return (
    <>
      <Wizard
        value={wizardStep}
        options={options}
        onChange={changeWizardStep}
      />
      <SpacingVertical variant={SPACING_24} />
      {wizardStep === 1 && <TaskStep1 />}
      {wizardStep === 2 && <TaskStep2 />}
      {wizardStep === 3 && <TaskStep3 />}
      {wizardStep === 4 && <TaskStep4 />}
      {wizardStep === 5 && <TaskStep5 />}
    </>
  )
}

export default WizardContainer
